// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BC-Page__Settings .list {
  display: flex;
  flex-wrap: wrap;
  gap: 16px; /* Gap between items */
}

.BC-Page__Settings .Polaris-Card {
  margin-top: 24px;
}

.BC-Page__Settings .Polaris-Card .Polaris-Card__Section {
  padding: 24px 20px;
}

.BC-Page__Settings .list .item {
  flex: 0 0 calc((100% - 32px) / 3); /* Allow exactly 3 items in a row, accounting for gaps */
  padding: 8px 16px 16px;
  display: flex;
  gap: 8px;
  border-radius: 4px;
}

.BC-Page__Settings .list .item:hover {
  cursor: pointer;
  background-color: #f6f6f7;
}

.BC-Page__Settings .list .item .content .name {
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  margin-bottom: 4px;
  display: flex;
  gap: 8px;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/styles/settings.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,SAAS,EAAE,sBAAsB;AACnC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iCAAiC,EAAE,wDAAwD;EAC3F,sBAAsB;EACtB,aAAa;EACb,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB","sourcesContent":[".BC-Page__Settings .list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px; /* Gap between items */\n}\n\n.BC-Page__Settings .Polaris-Card {\n  margin-top: 24px;\n}\n\n.BC-Page__Settings .Polaris-Card .Polaris-Card__Section {\n  padding: 24px 20px;\n}\n\n.BC-Page__Settings .list .item {\n  flex: 0 0 calc((100% - 32px) / 3); /* Allow exactly 3 items in a row, accounting for gaps */\n  padding: 8px 16px 16px;\n  display: flex;\n  gap: 8px;\n  border-radius: 4px;\n}\n\n.BC-Page__Settings .list .item:hover {\n  cursor: pointer;\n  background-color: #f6f6f7;\n}\n\n.BC-Page__Settings .list .item .content .name {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 24px;\n  margin-bottom: 4px;\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
